import { createContext, useContext, useState, useCallback, type ReactNode } from "react";
import { translations, type Lang, type TranslationKey } from "./translations";

interface I18nContext {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (key: TranslationKey) => string;
}

const I18nCtx = createContext<I18nContext>({
  lang: "tr",
  setLang: () => {},
  t: (key) => key,
});

export function I18nProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>(
    () => (localStorage.getItem("dashboard_lang") as Lang) || "tr"
  );

  const setLang = useCallback((l: Lang) => {
    setLangState(l);
    localStorage.setItem("dashboard_lang", l);
  }, []);

  const t = useCallback(
    (key: TranslationKey) => translations[lang]?.[key] || translations.tr[key] || key,
    [lang]
  );

  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export function useI18n() {
  return useContext(I18nCtx);
}

export type { Lang, TranslationKey };
